module.exports = __webpack_public_path__ + "img/2.093c5cf5.webp";